module.exports = __webpack_public_path__ + "static/media/Facebook.8d079a11.png";